import React, { ChangeEvent, forwardRef, HTMLAttributes } from 'react';
import { styled } from 'linaria/react';
import { CrossIcon } from '@shared/assets/icons';
import { typographyPxSizes, typographyRemSizes, withTheme } from '@shared/lib/theme';
interface SearchInputMobileProps extends Omit<HTMLAttributes<HTMLInputElement>, 'onChange'> {
  value: string;
  onChange: (value: string) => void;
}
const SearchInputMobile = forwardRef<HTMLInputElement, SearchInputMobileProps>(({
  value,
  onChange,
  ...rest
}, ref) => {
  const handleValueChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value || '');
  };
  const handleInputClearClick = () => {
    onChange('');
  };
  return <SearchInputWrapper>
      <Input ref={ref} value={value} onChange={handleValueChange} {...rest} />
      <IconWrapper onClick={handleInputClearClick}>
        <CrossIcon />
      </IconWrapper>
    </SearchInputWrapper>;
});
export default SearchInputMobile;
const SearchInputWrapper = /*#__PURE__*/styled('div')({
  name: "SearchInputWrapper",
  class: "s2l79m",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.stroke.default;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.primary;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.typography.family.MTSWide;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.typography.weight.medium;
const _exp6 = /*#__PURE__*/() => () => typographyRemSizes.size.pS;
const _exp7 = /*#__PURE__*/() => () => typographyRemSizes.lineHeight.pS;
const _exp8 = /*#__PURE__*/() => () => typographyRemSizes.letterSpacing.pS;
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.secondary;
const _exp0 = /*#__PURE__*/() => () => typographyPxSizes.size.pS;
const _exp1 = /*#__PURE__*/() => () => typographyPxSizes.lineHeight.pS;
const _exp10 = /*#__PURE__*/() => () => typographyPxSizes.letterSpacing.captionL;
const Input = withTheme(/*#__PURE__*/styled('input')({
  name: "Input",
  class: "inx4d1h",
  propsAsIs: false,
  vars: {
    "inx4d1h-0": [_exp()],
    "inx4d1h-1": [_exp2()],
    "inx4d1h-2": [_exp3()],
    "inx4d1h-3": [_exp4()],
    "inx4d1h-4": [_exp5()],
    "inx4d1h-5": [_exp6()],
    "inx4d1h-6": [_exp7()],
    "inx4d1h-7": [_exp8()],
    "inx4d1h-8": [_exp9()],
    "inx4d1h-9": [_exp0()],
    "inx4d1h-10": [_exp1()],
    "inx4d1h-11": [_exp10()]
  }
}));
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.primary;
const IconWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "IconWrapper",
  class: "izuugs1",
  propsAsIs: false,
  vars: {
    "izuugs1-0": [_exp11()]
  }
}));

require("./SearchInputMobile.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SearchInputMobile.tsx");